var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:{
    'mdc-text-field-helper-text': _vm.type === 'text',
    'mdc-select-helper-text': _vm.type === 'select',
  },attrs:{"id":((_vm.id || _vm._uid) + "-helper-text"),"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }